var map = {
	"./music-instructions.json": 4304,
	"./music-library-intro2024.json": 4305,
	"./music-library-launch2024.json": 4306,
	"./music-progression.json": 4307,
	"./startSourcesAdvanced.json": 4308,
	"./startSourcesSimple.json": 4309,
	"./startSourcesSimple2.json": 4310,
	"./startSourcesTracks.json": 4311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4040;